import { CourseFinancialFilterDatamodel } from '../side-bar-filter/course-financial-side-bar-filter-datamodel';
import appApi from '../../../../../api/app-api';
import { CourseFinancialAmongBranchesType } from '../../../../../api/types/reports/finanace/course-financial-among-branches.type';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const getCourseFinancialBetweenBranchesOperations = async (
  filters: CourseFinancialFilterDatamodel,
  setLoading: (loading: boolean) => void,
  setData: (data: CourseFinancialAmongBranchesType[]) => void,
) => {
  try {
    if (!filters.courseId) {
      toast.warn('תחילה יש לבחור תוכנית לימודים וקורס');
      return;
    }

    setLoading(true);
    const res = await appApi.getCourseFinancialAmongAllBranches(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setLoading(false);

    setData(res.data.body);
  } catch (error) {
    console.error('Error fetching financial data:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  } finally {
    setLoading(false);
  }
};
